
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-1e21431e&scoped=true!../../../vue-loader/lib/selector?type=styles&index=0!./CalendarDay.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./CalendarDay.vue"),
  /* template */
  null,
  /* scopeId */
  "data-v-1e21431e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/components/CalendarDay.vue
// module id = 1385
// module chunks = 94